/**
 * TextTypeWriterAnimation.js
 * 
 * Created on 26/01/2016
 *
 * @author Henrique Campos for Ranj
 **/

import { isNull } from "/lib/html5-software-library/src/ranj/util/TypeUtil";

const TextTypeWriterAnimation = {};
export default TextTypeWriterAnimation;

TextTypeWriterAnimation.animate = (textField, resultText, timeInSecs, delayInSecs, onComplete, onCompleteScope, onUpdateCallback) => {
    const delay = isNull(delay) ? 0 : delayInSecs * 1000;
    const time = timeInSecs * 1000;

    const animation = function () {
        // Lerps a value from 0 to 1, and uses it to determine the substring size to show in the text field
        const proxy = { value: 0 };
        const onUpdate = function (e) {
            // calculate substring size
            textField.text = resultText.substring(0, Math.ceil(resultText.length * proxy.value));
            if (onUpdateCallback) {
                onUpdateCallback.call(this);
            }
        }
        const onTweenComplete = function () {
            if (onComplete != null) {
                onComplete.call(onCompleteScope, this);
            }
        }.bind(this);
        createjs.Tween.get(proxy, { onChange: onUpdate }).wait(delay).to({ value: 1 }, time, createjs.Ease.linear).call(onTweenComplete);

        // forces the animation to finish
        this.forceFinish = function () {
            createjs.Tween.removeTweens(proxy);
            proxy.value = 1;
            onUpdate();
            onTweenComplete();
        };

        return this;
    }

    return new animation();
}